import { SxProps } from '@mui/material';

export const sxTermosUsoModal: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '650px',
  width: '85%',
  bgcolor: '#fff',
  borderRadius: '16px',
  border: 'none',
  boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
  padding: '32px',
  maxHeight: '100vh',
  overflow: 'auto',
  outline: 'none',
};
